import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
dayjs.extend(duration);

export const getFormattedTime = (milliseconds: number = 0, format: string) => {
  const duration = dayjs.duration(milliseconds);

  const days = duration.days();
  const hours = duration.hours();
  const minutes = duration.minutes();
  const seconds = duration.seconds();

  switch (format) {
    case 'ddd hhh mmm sss': {
      const formattedTimeArray: string[] = [];

      if (days > 0) {
        formattedTimeArray.push(`${days}d`);
      }

      if (hours > 0) {
        formattedTimeArray.push(`${hours}h`);
      }

      if (minutes > 0) {
        formattedTimeArray.push(`${minutes}m`);
      }

      if (days === 0 && hours === 0 && seconds > 0) {
        formattedTimeArray.push(`${seconds}s`);
      }

      return formattedTimeArray.join(' ');
    }
    case 'HH:mm:ss': {
      return `${padTo2Digits(hours + days * 24)}:${padTo2Digits(minutes)}:${padTo2Digits(seconds)}`;
    }
    case 'mm:ss': {
      return `${padTo2Digits(minutes)}:${padTo2Digits(seconds)}`;
    }
    case 'hhh mmm sss': {
      const formattedTimeArray: string[] = [];
      if (hours > 0) {
        formattedTimeArray.push(`${hours + days * 24}h`);
      }

      if (minutes > 0) {
        formattedTimeArray.push(`${minutes}m`);
      }

      if (seconds > 0) {
        formattedTimeArray.push(`${seconds}s`);
      }

      return formattedTimeArray.join(' ');
    }
    default: {
      return milliseconds;
    }
  }
};

export function padTo2Digits(num: number) {
  return num.toString().padStart(2, '0');
}
